import { actionsToArray } from '@noven-prime/lattice-core';
import { aiAssistActions } from './actions.js';
/**
 * AI Assist Capability Manifest
 *
 * Text enhancement for portal editors, powered by the Claude model
 * configured in portal settings.
 */
export const aiAssistManifest = {
    id: 'ai-assist',
    name: 'AI Assist',
    description: 'Enhance site copy with the configured Claude model',
    version: '1.0.0',
    surfaces: {
        allowed: '*',
    },
    experiences: {
        allowed: '*',
    },
    actions: actionsToArray(aiAssistActions),
    features: [
        {
            id: 'text-enhancement',
            name: 'Text Enhancement',
            description: 'Improve copy with AI before publishing',
            actions: actionsToArray(aiAssistActions),
        },
    ],
};
//# sourceMappingURL=manifest.js.map